
// import axios from "axios";
// import { useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import BASE_URL, { endpoints } from "../Apis/endpoints";



//   const Googledata =()=>{
//     const navigate = useNavigate();
//     const userHandler = async ()=>{
//       console.log("dataaa handleing google")
//         // console.log("userHanderler")
//         const query = window.location.search;
//         // aws endpoint 

//         var endpoint = `${BASE_URL}${endpoints.GOOGLE_LOGIN}${query}`
//         console.log(endpoint,"endpint in google data")
//         // var endpoint = `http://3.110.204.201:8080/googleauth/google${query}`;
//         var method = 'GET'
       
//         axios({
//             method: method,
//             url: endpoint,
//             headers: {
//                 'Content-Type': 'application/json',
//               },
//         }).then(response => {
      
//             console.log(response);
//             if(response.data.Token != null){
//                 // localStorage.setItem('stud_info', JSON.stringify(response.data));
//                 // localStorage.setItem('token',response.data.Token);
//                 // localStorage.setItem('userdata',JSON.stringify(response.data.user_data))

//                 localStorage.setItem('access_token', response.data.access);
//                 localStorage.setItem('refresh_token', response.data.refresh);
//                 localStorage.setItem('user', response.data.fullname);
//                 localStorage.setItem('user_id', response.data.user_id);
//                 navigate('/upload');
//             }
//         })
//       }
      
//       useEffect(()=>{
//         console.log("useEFfect")
//         console.log(localStorage.getItem('token'))
//         if(localStorage.getItem('token')==null){
//             console.log(userHandler());
//         }
//       },[]);

//   }

//   export default Googledata;

import axios from "axios";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import BASE_URL, { endpoints } from "../Apis/endpoints";

const Googledata = () => {
  console.log("Handling Google OAuth Response...");
    const navigate = useNavigate();

    useEffect(() => {
        const userHandler = async () => {
            console.log("Handling Google OAuth Response...");

            const query = new URLSearchParams(window.location.search);
            const code = query.get("code");

            if (!code) {
                console.error("No code found in URL!");
                return;
            }

            try {
                const endpoint = `${BASE_URL}${endpoints.GOOGLE_LOGIN}?code=${code}`;
                console.log("Google Login API Endpoint:", endpoint);

                const response = await axios.get(endpoint, {
                    headers: { "Content-Type": "application/json" },
                });

                console.log("Google Login Response:", response.data);

                if (response.data.access) {
                    localStorage.setItem("access_token", response.data.access);
                    localStorage.setItem("refresh_token", response.data.refresh);
                    localStorage.setItem("user", response.data.fullname);
                    localStorage.setItem("user_id", response.data.user_id);
                    navigate("/upload");
                } else {
                    console.error("Login failed, no access token received.");
                }
            } catch (error) {
                console.error("Error during Google OAuth:", error);
            }
        };

        userHandler();
    }, []);

};

export default Googledata;

